export default "__VITE_ASSET__CoY6t2LR__"